import { AudienceTypeOptions as AudienceTypeOptionsType } from '../../../../util/demographics';

import { AudienceTypeOption } from './AudienceTypeOption';

export const AudienceTypeOptions = ({
  audienceSource,
  panelProvider,
  onChange,
  value,
}: {
  audienceSource: string;
  panelProvider: string | null;
  onChange(value: AudienceTypeOptionsType): void;
  value: AudienceTypeOptionsType;
}): JSX.Element => {
  return (
    <div className="space-y-2 text-sm">
      <AudienceTypeOption
        currentValue={value}
        label="Natural Fallout"
        onChange={onChange}
        optionValue="natural"
      />
      <AudienceTypeOption
        currentValue={value}
        disabled={
          audienceSource !== 'sample-provider' || panelProvider !== 'LUCID'
        }
        label="Custom Audience"
        onChange={onChange}
        optionValue="custom"
      />
    </div>
  );
};
